import { render } from "./UserRepassForm.vue?vue&type=template&id=75d329d2"
import script from "./UserRepassForm.vue?vue&type=script&lang=js"
export * from "./UserRepassForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__